import { ContactServiceAction } from "./types";

export const createDeskTicket = () =>
  ({
    type: ContactServiceAction.CREATE_DESK_TICKET,
  }) as const;

export const uploadImage = (payload) =>
  ({
    type: ContactServiceAction.UPLOAD_IMAGE,
    payload,
  }) as const;

export const cleanUpstate = () =>
  ({
    type: ContactServiceAction.CLEAN_UP,
  }) as const;

export const updateCSState = (payload) =>
  ({
    type: ContactServiceAction.UPDATE_STATE,
    payload,
  }) as const;
